var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{attrs:{"text":_vm.targetStatus.label,"color":_vm.targetStatus.color,"outlined":_vm.outlined}})}
var staticRenderFns = []

export { render, staticRenderFns }